<script>
  import Editor from './Editor.svelte';
  import Container from './Container.svelte';
  import Button from './Button.svelte';
  import Modal from './Modal.svelte';

  import { publishedService } from '../stores.js';

  export let code = '';
  export let user;

  let conditionsModalVisible = false;
</script>

<Container>
  <Editor language='python' bind:data={code}/>
  <Button on:click={() => {conditionsModalVisible = true}}>Deploy</Button>
</Container>

<Modal bind:visible={conditionsModalVisible}>

  <h1>
    Just so we're clear...
  </h1>
  <h2>
    <span style="color: var(--primary)">✓</span> This is cool
  </h2>

  <ul>
    <li>
      Clever code
    </li>
    <li>
      Making the world a better place
    </li>
    <li>
      Anything fun
    </li>
  </ul>

  <h2>
    <span style="color: red">&#x2715;</span> Please don't bring
  </h2>

  <ul>
    <li>
      Harassment, bulling, violence
    </li>
    <li>
      Copyright/trademark infringement
    </li>
    <li>
      Pornography
    </li>
  </ul>

  <p style="color: #aaa">You can see the full list of restrictions in the <a href="/about/terms">Terms & Conditions</a></p>
  <div>
    <Button on:click={() => {conditionsModalVisible = false}}>Go back...</Button>
    <Button style="background-color: var(--primary)" on:click={async () => {
      conditionsModalVisible = false;
      let metadata = await user.publish(code);
      publishedService.update(() => metadata)
    }}>All good!!</Button>
  </div>

</Modal>

<style>
  h2 {
    margin-top: 50px;
  }
  ul {
    list-style-type: none;
  }

</style>